import { useApplicantFieldBindings } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantFieldBindings";
import { useApplicantFieldVisibility } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantFieldVisibility";
export const applicantBindingsAndVisibilities = (applicantIndex, applicantId) => {
  const {
    salutation,
    firstName,
    middleName,
    lastName,
    email,
    phoneNumber,
    altPhoneNumber,
    workPhone,
    firstTimeHomeBuyer,
    maritalStatus,
    sin,
    dateOfBirth,
    numChildren,
    languagePreference,
    own,
    monthlyRent,
    coApplicantType,
    relationshipToMainApplicant,
    addresses
  } = useApplicantFieldBindings({
    applicantIndex
  });
  const {
    applicantSalutationVisible,
    applicantFirstNameVisible,
    applicantMiddleNameVisible,
    applicantLastNameVisible,
    applicantEmailVisible,
    applicantPhoneNumberVisible,
    applicantWorkPhoneVisible,
    applicantAltPhoneNumberVisible,
    applicantFirstTimeHomeBuyerVisible,
    applicantMaritalStatusVisible,
    applicantDateOfBirthVisible,
    applicantNumChildrenVisible,
    applicantLanguagePreferenceVisible,
    applicantOwnVisible,
    applicantMonthlyRentVisible,
    coApplicantTypeVisible,
    applicantRelationshipToMainApplicantVisible,
    applicantAddressesVisible,
    applicantSinVisible
  } = useApplicantFieldVisibility({
    applicantIndex,
    applicantId
  });
  return {
    bindings: {
      salutation,
      firstName,
      middleName,
      lastName,
      email,
      phoneNumber,
      altPhoneNumber,
      workPhone,
      firstTimeHomeBuyer,
      maritalStatus,
      sin,
      dateOfBirth,
      numChildren,
      languagePreference,
      own,
      monthlyRent,
      coApplicantType,
      relationshipToMainApplicant,
      addresses
    },
    visibilities: {
      applicantSalutationVisible,
      applicantFirstNameVisible,
      applicantMiddleNameVisible,
      applicantLastNameVisible,
      applicantEmailVisible,
      applicantPhoneNumberVisible,
      applicantWorkPhoneVisible,
      applicantAltPhoneNumberVisible,
      applicantFirstTimeHomeBuyerVisible,
      applicantMaritalStatusVisible,
      applicantDateOfBirthVisible,
      applicantNumChildrenVisible,
      applicantLanguagePreferenceVisible,
      applicantOwnVisible,
      applicantMonthlyRentVisible,
      coApplicantTypeVisible,
      applicantRelationshipToMainApplicantVisible,
      applicantAddressesVisible,
      applicantSinVisible
    }
  };
};